import VideoJsAdapter from '@javascripts/adapters/videojs_adapter';
import TopicAdapter from '@javascripts/adapters/topic_adapter';
import FullscreenApiAdapter from '@javascripts/adapters/fullscreen_api_adapter';
import { PlayerAhoyEvent } from '../player_ahoy_event';

export default class ButtonSubscribe {
  constructor({ data, tech } = {}) {
    this._tech = tech;
    this._data = data;
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  previewDuration(){
    if(this.data()){
      return this.data().previewDuration();
    }

    return undefined;
  }

  hasPreviewDuration() {
    return this.previewDuration() != undefined && this.previewDuration() !== -1;
  }

  remainingPreviewDuration(){
    return this._remainingPreviewDuration;
  }

  init() {
    if(this.hasPreviewDuration()) this._remainingPreviewDuration = this.previewDuration();

    this._blocker = this.getBlocker();
    this.appendSubscribeButtonOnStart();
  }

  getBlocker() {
    return (
      document.querySelector('.watchpage-premium-banner') ||
      document.querySelector('.b-watchpage-premium-banner') ||
      document.querySelector('.b-premium-subscribe-banner') ||
      document.createElement(null)
    );
  }

  appendSubscribeButtonOnStart() {
    this.tech().one('playing', () => {
      this.tech().el().appendChild(this.createButton());

      if(this.hasPreviewDuration()){
        this.bindOneSecondInterval();
      }else{
        this.bindTimeUpdate();
      }

      this.sendEvent({ action: 'impression' });
    });
  }

  createButton() {
    this._button = document.createElement('button');
    this._button.className = 'subscribe-button';
    this._button.innerHTML = this.getButtonText();
    this._button.onclick = () => {
      FullscreenApiAdapter.exitFullscreen();
      this.tech().pause();
      TopicAdapter.publish('player/paymentblocker/show', {"source": "preview button"});
      this.appendBlockerCloseButton();
      this.sendEvent({ action: 'click' });
    };

    return this._button;
  }

  appendBlockerCloseButton() {
    this._blocker.appendChild(this.createBlockerCloseButton());
  }

  createBlockerCloseButton() {
    const button = document.createElement('button');
    button.className = 'playback-subscription-blocker-close-button';
    button.innerHTML = '×';
    button.onclick = () => {
      TopicAdapter.publish('player/paymentblocker/hide');
      this.tech().play();
      this.removeCloseButton(button);
    };

    return button;
  }

  removeCloseButton(button) {
    button.parentElement.removeChild(button);
  }

  getButtonText() {
    const remainingTime = this.hasPreviewDuration() ? this.remainingPreviewDuration() : this.remainingTime();
    const formattedTime = VideoJsAdapter.formatTime(remainingTime);

    return `<b>Aktifkan Premier</b>&nbsp; ${formattedTime}`;
  }

  remainingTime() {
    return Math.ceil(this.tech().remainingTime());
  }

  bindTimeUpdate() {
    this.tech().on('timeupdate', () => {
      this._button.innerHTML = this.getButtonText();
    });
  }

  bindOneSecondInterval(){
    let oneSecondInterval = setInterval(() => {
      this._remainingPreviewDuration -= 1;
      this._button.innerHTML = this.getButtonText();

      if(this.remainingPreviewDuration() <= 0) clearInterval(oneSecondInterval);
    }, 1000);
  }

  sendEvent({ action } = {}) {
    PlayerAhoyEvent.sendPreviewSubscribe(action, this.tech().currentTime());
  }
}
